<div class="custom-spin-container" [class.custom-spin-active]="spinning" [class.custom-spin-fill]="fillHeight" [class.custom-spin-scrollable]="fillHeight && scrollableContent" [style.--custom-spin-min-height]="minHeight">
  <div class="custom-spin-overlay" [class.custom-spin-opaque]="opaque" *ngIf="spinning">
    <ng-container *ngIf="indicator; else defaultIcon">
      <ng-container *ngTemplateOutlet="indicator"></ng-container>
    </ng-container>
    <ng-template #defaultIcon>
      <img src="assets/custom-loader/custom-loading-focali.svg" alt="Loading" class="custom-spin-icon"
        [class.custom-spin-icon-small]="size === 'small'" />
    </ng-template>
    <div class="custom-spin-tip" *ngIf="tip">{{ tip }}</div>
  </div>

  <div class="custom-spin-content" [class.custom-spin-blurred]="spinning">
    <ng-content></ng-content>
  </div>
</div>